import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import BankAccountAddModalUI from './BankAccountAddModalUI'

class BankAccountAddModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            successMsg: null,
            errorList: null,

            // form events
            submitted: false,
            // form field
            bankAccountNumber: '',
            bankAccountNumberError: null,
            ifscCode: '',
            ifscCodeError: null,
        }
    }

    render() {
        return (
            <BankAccountAddModalUI
                context={this.props.context}
                errorList={this.state.errorList}
                successMsg={this.state.successMsg}
                setErrorList={this.setErrorList}
                // modes
                addBankAccountMode={this.props.addBankAccountMode}
                submitted={this.state.submitted}
                // event handlers
                onSubmit={this.onSubmit}
                onCancelClick={this.props.onCancelAddBankAccount}
                // form fields
                bankAccountNumber={this.state.bankAccountNumber}
                onbankAccountNumberChange={(event) => this.setState({ bankAccountNumber: event.target.value })}
                bankAccountNumberError={this.state.bankAccountNumberError}
                setbankAccountNumberError={(error) => { this.setState({ bankAccountNumberError: error }) }}

                ifscCode={this.state.ifscCode}
                onifscCodeChange={(event) => this.setState({ ifscCode: event.target.value })}
                ifscCodeError={this.state.ifscCodeError}
                setifscCodeError={(error) => { this.setState({ ifscCodeError: error }) }}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        Modal.setAppElement('body')
    }

    onSubmit = () => {
        let submitted = this.state.submitted
        if (submitted)
            return

        this.setState({
            successMsg: null,
            errorList: [],
            submitted: true
        })

        RestApiUtils.post(this.props.context,
            `/api/su/accounts/${this.props.account.accountId}/escrowAccounts`,
            this.onSubmitCallback, {
            bankAccountNumber: this.state.bankAccountNumber,
            ifscCode: this.state.ifscCode
        }
        )
    }

    onSubmitCallback = (response) => {
        let errorList = []
        response.errorList.forEach(error => {
            errorList.push(error.message)
        })

        this.setState({
            successMsg: response.success,
            errorList: errorList,
            submitted: false
        })

        if (response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({
                    successMsg: null
                })
                this.props.onCancelAddBankAccount()
            }, 2000)
        }
    }

    setErrorList = (errorList) => {
        this.setState({ errorList: errorList })
    }
}

export default withRouter(BankAccountAddModalSF)
